import { useSelector, useDispatch } from "react-redux";
import { setUser, initialState } from "store/auth/userSlice";
import { apiSignIn, apiSignUp } from "services/AuthService";
import { onSignInSuccess, onSignOutSuccess } from "store/auth/sessionSlice";

import appConfig from "configs/app.config";
import { REDIRECT_URL_KEY } from "constants/app.constant";

import { useNavigate } from "react-router-dom";
import useQuery from "./useQuery";


export const SESSION_EXPIRES_AT_KEY = "sessionExpiresAt";

export const DASHBOARD_SPLASH_KEY = "dashboard_splash_shown";

function useAuth() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const query = useQuery();

  const { token, signedIn } = useSelector((state) => state.auth.session);

  /*
    -----------------------------
    SIGN IN
    -----------------------------
    */

  const signIn = async (values) => {
    try {
      const { data: resp } = await apiSignIn(values);

      if (resp?.status === "success" && resp?.data) {
        const userData = resp.data;

        /*
                1. save token first
                */
        dispatch(onSignInSuccess(userData.token));

        /*
                2. save user data
                */
        dispatch(
          setUser({
            ...userData,

            authority: userData.role_code === "ADMIN" ? ["admin"] : ["user"],
          }),
        );

        /*
                3. reset session flags
                */
        sessionStorage.removeItem(DASHBOARD_SPLASH_KEY);

        /*
                optional expiry tracking
                */
        // const expiresAt =
        //     Date.now()
        //     + SESSION_TTL_MS;

        // localStorage.setItem(
        //     SESSION_EXPIRES_AT_KEY,
        //     String(expiresAt)
        // );

        /*
                4. compute redirect path
                */
        const redirectUrl = query.get(REDIRECT_URL_KEY);

        const destination =
          redirectUrl ||
          (userData.role_code === "ADMIN"
            ? "/notification-settings"
            : appConfig.authenticatedEntryPath);

        /*
                5. navigate AFTER state updated
                */
        Promise.resolve().then(() => {
          navigate(destination, {
            replace: true,
          });
        });

        return {
          status: "success",
        };
      }

      return resp;
    } catch (error) {
      return {
        status: "error",

        message: error?.response?.data?.message || error.toString(),
      };
    }
  };

  /*
    -----------------------------
    SIGN OUT
    -----------------------------
    */

  const signOut = () => {
    dispatch(onSignOutSuccess());

    dispatch(setUser(initialState));

    localStorage.removeItem(SESSION_EXPIRES_AT_KEY);

    sessionStorage.removeItem(DASHBOARD_SPLASH_KEY);

    navigate(appConfig.unAuthenticatedEntryPath, {
      replace: true,
    });
  };

  /*
    -----------------------------
    AUTH STATE
    -----------------------------
    */

  const authenticated = Boolean(token && signedIn);

  return {
    authenticated,

    signIn,

    signUp: apiSignUp,

    signOut,
  };
}

export default useAuth;
